import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createAtmCompany = ( {data} : {data: IPostNewAtmCompany | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/AtmCompanies/InsertAtmCompany`, data);
};

type QueryFnType = typeof createAtmCompany;

type UseCreateAtmCompanyOptions = {
  data: IPostNewAtmCompany | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateAtmCompany = ({ config }: UseCreateAtmCompanyOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της Εταιρίας.`, 500);
            console.error('Couldnt create new atm company', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllAtmCompanies"])
            addNotification("Δημιουργήθηκε Νέα Εταιρία.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createAtmCompany,
    })
}